import { lazy } from 'react'

import { Features } from 'generated/featureDefinitions'
import { MyProjectsRoutesDocument } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const MyProjectsRootPage = lazy(() => import('modules/project_management/pages/MyProjectsRootPage'))
const MyProjectsDefaultPage = lazy(
  () => import('modules/project_management/pages/MyProjectsDefaultPage')
)
const MyProjectsPage = lazy(() => import('modules/project_management/pages/MyProjectsPage'))
const MyProjectsOverviewPage = lazy(
  () => import('modules/project_management/pages/MyProjectsPage/OverviewPage')
)
const MyProjects = lazy(() => import('modules/project_management/pages/MyProjectsPage/MyProjects'))
const MyProjectsSchedulePage = lazy(
  () => import('modules/project_management/pages/MyProjectsPage/SchedulePage')
)

export const myProjectsRoutes: NavigationRoutesFn = (navigation) => {
  const now = moment()
  const year = now.startOf('week').format('YYYY')
  const month = now.startOf('week').format('MM')
  const day = now.startOf('week').format('DD')

  return [
    {
      path: navigation.myProjects.path,
      element: <MyProjectsRootPage />,
      handle: {
        module: 'my_projects',
        meta: ({ watchQuery, session }) => {
          return watchQuery({
            query: MyProjectsRoutesDocument,
            variables: {
              companyId: Number(session.company.id),
              featureIds: [Features.projects_overview],
            },
          }).map(({ data }) => {
            const hasScheduleView = !!data?.companies.featureAvailabilitiesConnection.nodes.find(
              (feature) => feature.id === Features.projects_overview
            )?.available

            const employeeId = session.employee?.id
            if (!employeeId) return

            return {
              title: i18n.t('project_management.meta_data.my_projects.title'),
              description: i18n.t('project_management.meta_data.my_projects.description'),
              subNavigation: [
                {
                  id: 'navigation.myProjects.employeeId.overview.path',
                  title: i18n.t('project_management.my_projects.tabs.overview'),
                  href: navigation.myProjects.employeeId.overview.fullPath({
                    employeeId: employeeId,
                  }),
                },
                {
                  id: 'navigation.myProjects.employeeId.yearMonthDay.path',
                  title: i18n.t('project_management.my_projects.tabs.tracking'),
                  href: navigation.myProjects.employeeId.yearMonthDay.fullPath({
                    employeeId: employeeId,
                    year,
                    month,
                    day,
                  }),
                },
                {
                  id: 'navigation.myProjects.employeeId.schedule.path',
                  title: i18n.t('project_management.my_projects.tabs.schedule'),
                  href: navigation.myProjects.employeeId.schedule.fullPath({
                    employeeId: employeeId,
                  }),
                  isVisible: hasScheduleView,
                },
              ],
            }
          })
        },
      },

      children: [
        {
          index: true,
          element: <MyProjectsDefaultPage />,
        },
        {
          path: navigation.myProjects.employeeId.path,
          element: <MyProjectsPage />,
          children: [
            {
              path: navigation.myProjects.employeeId.overview.path,
              element: <MyProjectsOverviewPage />,
            },
            {
              path: navigation.myProjects.employeeId.yearMonthDay.path,
              element: <MyProjects />,
            },
            {
              path: navigation.myProjects.employeeId.schedule.path,
              element: <MyProjectsSchedulePage />,
            },
          ],
        },
      ],
    },
  ]
}
